import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective implements OnInit, OnDestroy {
  private elseTemplate: TemplateRef<any> | null = null;
  private _role: number | null = null;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.userDataUpdated
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateView());
  }

  @Input() set appHasRole(role: number) {
    this._role = role;
    this.updateView();
  }

  @Input() set appHasRoleElse(template: TemplateRef<any> | null) {
    this.elseTemplate = template;
    this.updateView();
  }

  private updateView() {
    if (this._role === null) return;

    this.viewContainer.clear();
    if (this.authService.hasRole(this._role)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.elseTemplate) {
      this.viewContainer.createEmbeddedView(this.elseTemplate);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
